import { render, staticRenderFns } from "./FetchPurchaseFromApi.vue?vue&type=template&id=50710932&"
import script from "./FetchPurchaseFromApi.vue?vue&type=script&lang=js&"
export * from "./FetchPurchaseFromApi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports